import StarterKit from "@tiptap/starter-kit";
import html2pdf from "html2pdf.js";
import { Editor } from "@tiptap/react";

interface Page {
  id: number;
  content: string;
  title: string;
}

const createStyledHtmlContainer = async (
  pages: Page[],
  extensions: any[]
): Promise<HTMLElement> => {
    
  const container = document.createElement('div');

  const styleElement = document.createElement('style');
  styleElement.textContent = `
    body {
        font-family: Arial, sans-serif;
        line-height: 1.6;
        margin: 0;
        padding: 20px;
        color: #000000;
    }

    table.table {
        margin: 0 auto;
        width: 100%;
        border-collapse: collapse;
    }

    table.table td,
    table.table th {
        padding: 6px;
        border: 1px solid #686868;
        background-clip: padding-box;
    }

    .blockquote {
        border-left: 4px solid #706f6f;
        margin: 1em 0;
        padding: 0.5em;
        background-color: #d4d4d4;
        color: #555;
    }

    .codeblock {
        background-color: #1e1e1e;
        color: #ddd;
        font-family: 'Fira Code', 'Courier New', monospace;
        font-size: 0.95rem;
        padding: 1em;
        overflow-x: auto;
        margin: 1em 0;
        border: 1px solid #333;
        white-space: pre;
    }

    .code {
        background-color: #f5ccc4;
        padding: 0.2em;
        border-radius: 5px;
        font-family: 'Courier New', monospace;
    }

    .image {
        max-width: 100%;
    }

    .highlight {
        border-radius: 0.4rem;
        padding: 0.1rem 0.3rem;
    }

    .page-break {
        page-break-after: always;
        break-after: page;
    }
  `;
  container.appendChild(styleElement);

  pages.forEach((page) => {
    
    const section = document.createElement('div');

    const tempEditor = new Editor({
      content: page.content, // This is your JSON
      editable: false,
      extensions: extensions
    });

    const content = document.createElement('div');
    content.innerHTML = tempEditor.getHTML();
    section.appendChild(content);

    section.classList.add('page-break');
    container.appendChild(section);
  });

  return container;
};

const generatePDF = async (container: HTMLElement, filename: string) => {
  return html2pdf()
    .from(container)
    .set({
      margin: [10, 10, 10, 10],
      filename: `${filename}.pdf`,
      html2canvas: {
        scale: 2,
        useCORS: true,
        allowTaint: true,
      },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'portrait',
        compress: true,
      },
    })
    .outputPdf('blob')
    .then((pdfBlob: Blob) => {
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, '_blank');
    })
    .catch((error: any) => {
      console.error('Error generating PDF:', error);
    });
};

export default async function saveNotePDF(pages: Page[], title: string, extensions: any[]) {
  const htmlContent = await createStyledHtmlContainer(pages, extensions);
  await generatePDF(htmlContent, title);
}
